<template>
	<div>
		<div class="userWrapper">
			<!-- <p class="white">以下信息是测评结果的重要依据，也是测评报告的组成部分，请务必如实填写。</p> -->
      <p class="clearfix MineTitle">
        家庭信息 <span class="fr addChild" @click="addchild()" v-if="child.length==0">添加孩子</span>
      </p>
			<div class="info-list">
				<span class="fl info-desc" v-if="showChild">家庭创建人</span>
				<span class="fl info-desc" v-if="!showChild">姓名</span>
				<input type="text" class="info-input fr childrenName" v-bind:value="name" disabled/>
			</div>
			<div class="info-list" v-for="(li,index) in child" @click="goEdit(index)">
				<span class="fl info-desc">孩子</span>
				<input type="text" class="info-input fr childrenName" v-bind:value="li.name" disabled/>
			</div>
      <p class="clearfix MineTitle">测评记录</p>
      <p class="noData" v-if="reportList.length==0">暂无记录</p>
      <div class="clearfix reportWrapper" v-for="li in reportList">
        <div class="fl scaleInfo">
          <p class="scaleName">{{li.scalar.data.name}}</p>
          <p>{{li.created_at}}</p>
        </div>
        <div class="fr seeReport" @click="seeReport(li)">报告</div>
      </div>
			<!--<div class="info-list">
				<span class="fl info-desc">是孩子的</span>
				<span class="icon fr icon-you">&#xe636;</span>
				<p class="info-input fr trigger2">{{role | role}}</p>
			</div>
			<div class="info-list">
				<span class="fl info-desc">孩子的性别</span>
				<span class="icon fr icon-you">&#xe636;</span>
				<p class="info-input fr trigger1">{{sex | sex}}</p>
			</div>
			<div class="info-list">
				<span class="fl info-desc">孩子的生日</span>
				<span class="icon fr icon-you">&#xe636;</span>
				<input type="text" class="info-input fr birthday" readonly id="demo_date" v-bind:value="birthday"  />
			</div>
			<div class="info-list">
				<span class="fl info-desc">出生孕周</span>
				<span class="fr" style="color:rgba(153, 153, 153, 1)">周</span>
				<input type="text" class="info-input fr birth_week" v-bind:value="birth_week"  />
			</div>
			<div class="info-list">
				<span class="fl info-desc">出生体重</span>
				<span class="fr" style="color:rgba(153, 153, 153, 1)">kg</span>
				<input type="text" class="info-input fr birth_weight" v-bind:value="birth_weight"  />
			</div>
			<div class="info-list">
				<span class="fl info-desc">出生身高</span>
				<span class="fr" style="color:rgba(153, 153, 153, 1)">cm</span>
				<input type="text" class="info-input fr birth_height" v-bind:value="birth_height"  />
			</div>-->
			<!-- <div class="save-children" @click="addchild()" v-if="showChild">添加孩子</div> -->
      <!-- <div class="save-children" @click="addchild()" v-if="child.length==0">添加孩子</div> -->
		</div>
		<bottomBar :bottom="bottom"></bottomBar>
	</div>
</template>

<script>
	import bottomBar from '../components/bottomBar.vue'
	export default {
		data() {
			return {
				bottom: 2,
				childrenName:'',
				role:'',
				sex:'',
				birthday:'',
				birth_week:'',
				birth_weight:'',
				birth_height:'',
				children:'',
				name:'',
				child:[],
				showChild:false,
        reportList:[]
			}
		},
		created: function() {
			document.title = '我的';
			if(localStorage.getItem('user')==null || localStorage.getItem('user') == undefined){
				this.$router.push({name:'login'});
			}
			this.children = JSON.parse(localStorage.getItem('user'));
			var user = this.children;
			this.name = user.name;
			this.child = user.children.data;
			var insituation = sessionStorage.getItem('insituation');
			if(insituation==2648713){
				this.showChild = false;
			}else{
				this.showChild = true;
			}
      this.getList();
		},
		mounted:function(){},
		filters: {
            sex: function (value) {
                if(value==1){
                		return '男'
                }else if(value==2){
                		return '女'
                }else{
                		return '';
                }
            }
        },
		methods: {
      getList(){
        var that = this;
        var institution_id = sessionStorage.getItem('insituation');
        var openid = JSON.parse(localStorage.getItem('user')).openid;
        http.get('institutions/'+institution_id+'/users/'+openid+'/assesses').then(function(res) {
          for(var i=0;i<res.data.data.length;i++){
            res.data.data[i].created_at = res.data.data[i].created_at.split(' ')[0];
          }
          that.reportList = res.data.data;
        }).catch(function(res) {

        })
      },
			addchild:function(){
				this.$router.push({name:'addchild'})
			},
			goEdit:function(index){
				this.$router.push({name:'addchild',params:{id:index}});
			},
      seeReport(li){
        var link = li.scalar.data.link;
        if(li.children.data.length==0){
          window.location.href = toResult+link+'?number='+li.number+"&userid="+li.user.data.openid;
        }else{
          window.location.href = toResult+link+'?number='+li.number+"&userid="+li.user.data.openid;
        }
        
      }
		},
		mounted:function(){
//			this.trigger1();
//			this.trigger2();
//			$('#demo_date').mobiscroll().date({
//	            theme: "ios",
//	            mode: "scroller",
//	            display: "bottom",
//	            dateFormat:"yyyy-mm-dd",
//	            lang: "zh"
//	        });
		},
		components: {
			bottomBar
		},
	}
</script>

<style scoped>
	.userWrapper {
		padding-bottom: 1.5rem;
	}

	.white {
		height: 1rem;
		padding: 0.2rem;
		line-height: 0.4rem;
		/*border-bottom: 1px solid #EEEEEE;*/
		/*text-align: center;*/
		color: #e34e42;
		font-size: 0.24rem;
	}

	.info-list {
		height: 0.80rem;
		border-bottom: 1px solid #EEEEEE;
		line-height: 0.80rem;
		padding-right: 0.20rem;
		font-size: 0.24rem;
		padding-left: 0.20rem;
	}

	.info-desc {
		color: RGBA(102, 102, 102, 0.8);
	}

	.icon-you {
		color: RGBA(153, 153, 153, 0.8);
	}

	.info-input {
		width: 3rem;
		color: RGBA(51, 51, 51, 0.8);
		height: 0.80rem;
		text-align: right;
		background: #fff;
	}

	.save-children {
		width: 2.40rem;
		height: 0.60rem;
		line-height: 0.60rem;
		background: #26a2ff;
		color: #fff;
		text-align: center;
		font-size: 0.24rem;
		border-radius: 0.50rem;
		margin: 0.30rem auto;
	}
  .MineTitle{
    line-height: .6rem;font-weight: 600;color: #353535;margin-bottom: 10px;font-size: .36rem;margin-top: 30px;padding:0 .2rem;
  }
  .addChild{
    line-height: .6rem;font-size: .24rem;width: 2.4rem;border-radius:4px;color: #fff;background: #F8A300;text-align: center;
  }
  .scaleName{
    margin-bottom: .12rem;
  }
  .scaleInfo{
    font-size: .24rem;line-height: .24rem;color: #101010;
  }
  .reportWrapper{
    padding: .2rem;border-bottom: 1px solid #bbb;
  }
  .seeReport{
    font-size: .24rem;line-height: .6rem;width: 1.2rem;text-align: center;border-radius: 4px;background: #31BBF2;color: #fff;
  }
  .noData{
    line-height: 10vh;font-size: .4rem;text-align: center;color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/pages/userinfo.vue